import styled, { css } from "styled-components";

const Container = styled.div<{ full?: boolean }>`
  max-width: 100%;
  margin: 0 auto;

  ${({ full }) =>
    full
      ? css`
          padding: 0px;
        `
      : css`
          padding: 10px calc((100% - 90%) / 2);

          @media (min-width: 576px) {
            padding: 20px calc((100% - 80%) / 2);
          }

          @media (min-width: 768px) {
            padding: 20px calc((100% - 75%) / 2);
          }

          @media (min-width: 992px) {
            padding: 20px calc((100% - 70.3%) / 2);
          }

          @media (min-width: 1200px) {
            padding: 20px calc((100% - 70.3%) / 2);
          }

          @media (min-width: 1400px) {
            padding: 20px calc((100% - 70.3%) / 2);
          }
        `}
`;

export default Container;
